import {Routes} from '@angular/router';

export const wholesaleposRecommendationRoutes: Routes = [
  {
    path: 'wholesaleposRecommendation',
    loadComponent: () => import('./wholesalepos-recommendation.component').then(m => m.WholesaleposRecommendationComponent),
    data: { title: '收银机商品推荐' },
  },
];
